<template>
  <div id="app" @click="closePopups">
    <div id="menu" class="shadow" v-if="loggedIn">
      <router-link to="/"><img src="./assets/logo.svg"/></router-link>
      <ul>
        <li><router-link to="/">{{ $t('dashboard') }}</router-link></li>
        <li><router-link to="/companies">{{ $t('companies') }}</router-link></li>
        <li><router-link to="/contacts">{{ $t('contacts') }}</router-link></li>
        <li>
          <router-link to="/tickets">{{ $t('tickets') }}</router-link>
          <ul class="menu-child">
            <li><router-link to="/tickets/all">{{ $t('all-entities', { entity: $t('tickets') }) }}</router-link></li>
            <li><router-link to="/tickets/mine">{{ $t('my-entities', { entity: $t('tickets') }) }}</router-link></li>
          </ul>
        </li>

        <li>
          <router-link to="/test">Taken</router-link>
          <ul class="menu-child">
            <li><router-link to="/">{{ $t('all-entities', { entity: $t('tasks') }) }}</router-link></li>
            <li><router-link to="/">{{ $t('my-entities', { entity: $t('tasks') }) }}</router-link></li>
          </ul>
        </li>

        <li><router-link to="/logout">{{ $t('logout') }}</router-link></li>
      </ul>

      <p id="menu-copyright">&copy; CRM Bird {{ new Date().getFullYear() }}</p>
    </div>


      <div class="column column-100" v-if="loggedIn">
        <div id="greeting">
          <h1>{{ title.heading }}</h1>
          <p>{{ title.subheading }}</p>
        </div>

        <div id="controls">
          <div class="alerts shadow clickable" id="alert-popup-button">
            <button v-on:click="alertPopupActive = !alertPopupActive">
              <i class="fal fa-bell"></i>
            </button>

            <span class="notifications">{{alerts.length}}</span>
          </div>

          <transition name="fade">
            <div class="alert-popup shadow" v-show="alertPopupActive">
              <div class="single-alert" v-for="(alert, index) in alerts" v-bind:key="index">
                <div class="alert-icon"><i class="fal" :class="alert.icon"></i></div>
                <div class="alert-title">{{ alert.title }}</div>
                <div class="alert-subtitle">{{ alert.subtitle }}</div>
              </div>
            </div>
          </transition>

          <div class="new shadow clickable" id="new-popup-button">
            <button v-on:click="newPopupActive = !newPopupActive">
              <i class="fal fa-plus"></i>
            </button>
          </div>

          <transition name="fade">
            <div class="new-popup shadow" v-show="newPopupActive" @click="newPopupActive = false">
              <router-link tag="div" to="/companies/create" class="new-button">
                <i class="fal fa-building"></i><br/>
                <span class="new-label">{{ $t('company') }}</span>
              </router-link>

              <div class="new-button">
                <i class="fal fa-user"></i><br/>
                <span class="new-label">{{ $t('contact') }}</span>
              </div>

              <div class="new-button">
                <i class="fal fa-tasks"></i><br/>
                <span class="new-label">{{ $t('task') }}</span>
              </div>

              <div class="new-button">
                <i class="fal fa-ticket-alt"></i><br/>
                <span class="new-label">{{ $t('ticket') }}</span>
              </div>

              <div class="new-button">
                <i class="fal fa-calendar"></i><br/>
                <span class="new-label">{{ $t('appointment') }}</span>
              </div>

              <div class="new-button">
                <i class="fal fa-badge-check"></i><br/>
                <span class="new-label">{{ $t('deal') }}</span>
              </div>
            </div>
          </transition>

          <div class="search">
            <input class="shadow" type="text" :placeholder="$t('search-administration')"/>
          </div>
        </div>
      </div>

    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import User from './services/api/User';

export default {
  name: 'App',
  data() {
    const formattedDate = this.$t('date-today', {
      date: this.$moment().format(this.$t('date-today-format')),
    });

    return {
      formattedDate,
      newPopupActive: false,
      alertPopupActive: false,
      loggedIn: User.loggedIn(),
      user: User.get(),
      title: {
        heading: '',
        subheading: '',
      },
      alerts: [
        {
          icon: 'fa-badge-check',
          title: 'Deal vereist aandacht',
          subtitle: 'Website verkopen (Webtify)',
        },
        {
          icon: 'fa-badge-check',
          title: 'Deal vereist aandacht',
          subtitle: 'Website verkopen (Webtify)',
        },
        {
          icon: 'fa-badge-check',
          title: 'Deal vereist aandacht',
          subtitle: 'Website verkopen (Webtify)',
        },
      ],
    };
  },

  methods: {
    closePopups(event) {
      if(!this.newPopupActive && !this.alertPopupActive) return;

      const target = event.target;

      if(target.parentElement.id !== "new-popup-button" &&
        target.parentElement.parentElement.id !== "new-popup-button")
          this.newPopupActive = false;

      if(target.parentElement.id !== "alert-popup-button" &&
        target.parentElement.parentElement.id !== "alert-popup-button")
        this.alertPopupActive = false;
    },

    getGreeting() {
      const currentTime = new Date().getHours();
      let greeting = this.$t('goodevening');

      if (currentTime < 12) greeting = this.$t('goodmorning');
      else if (currentTime < 18) greeting = this.$t('goodafternoon');

      return greeting;
    },

    scrollToTop() {
      const c = document.documentElement.scrollTop || document.body.scrollTop;

      if (c > 0) {
        window.requestAnimationFrame(this.scrollToTop);
        window.scrollTo(0, c - (c / 8));
      }
    },

    pickRandom(array, params) {
      if(typeof array !== 'object') return array;

      const key = Math.ceil(Math.random() * array.length) - 1;
      let chosenValue = array[key];      

      if(params) {
        for(let paramKey in params) {
          chosenValue = chosenValue.replace(`{${paramKey}}`, params[paramKey]);
        }
      }

      return chosenValue;
    },

    changePrimaryColor(color) {
      const root = document.documentElement;
      root.style.setProperty('--primary-color', color);
    },

    getDirectionsUrl(address) {
      if(!address) return "";

      const encodedAddress = encodeURIComponent(`${address.street} ${address.number} ${address.city}`);
      return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
    }
  },
};
</script>

<style>
  :root {
    --primary-color: #3D70FF;
  }

  * {

    font-family: 'Montserrat', sans-serif;
  }

  html, body {
    background: rgb(241, 245, 255);
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    color: #6C6C6C;
  }

  @media (max-width: 1440px) { html { zoom: .8; } }
  @media (max-width: 1280px) { html { zoom: .7; } }

  input {
    outline: 0;
  }

  table {
    width: 100%;
  }

  #menu {
    position: fixed;
    width: 270px;
    background: white;
    top: 0;
    bottom: 0;
    left: 0;
    color: white;
    padding-left: 30px;
  }

  #menu img {
    width: 200px;
    margin-left: 10px;
    margin-top: 25px;
    margin-bottom: 50px;
  }

  #menu li a.is-active:before {
    position: absolute;
    content: " ";
    left: 50px;
    margin-top: -3px;
    width: 4px;
    height: 25px;
    background: #3D70FF;
    background: var(--primary-color);
    margin-right: 15px;
  }

  #menu a {
    color: #3D70FF;
    color: var(--primary-color);
    font-weight: bold;
    text-transform: uppercase;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  #menu ul {
    margin-top: 20px;
  }

  #menu li {
    list-style-type: none;
    margin-bottom: 20px;
  }

  #menu ul.menu-child li:before {
    positioN: absolute;
    content: " ";
    background: url('./assets/logo-bird.svg') no-repeat center;
    background-size: 100% 100%;
    width: 15px;
    height: 15px;
    margin-left: -25px;
  }

  #menu ul.menu-child li {
    list-style-type: none;
    margin-bottom: 10px;
  }

  #menu ul.menu-child li a {
    color: #8E8E8E;
    text-transform: none;
    font-weight: normal;
  }

  #menu #menu-copyright {
    position: fixed;
    color: #BFD0FF;
    text-align: center;
    left: 0;
    bottom: 0;
    width: 300px;
    font-size: 14px;
  }

  #app {
    width: auto;
    margin-left: 350px;
    margin-right: 50px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-top: 35px;
  }

  .fade-enter-active {
    transition-duration: .5s;
    transition-property: all;
    transition-timing-function: ease;
  }

  .fade-enter {
    opacity: 0;
    transform: translateY(30px);
  }

  .fade-from-right-enter {
    opacity: 0;
    transform: translateX(30px);
  }

  .fade-from-right-enter-active {
    transition-duration: .5s;
    transition-property: all;
    transition-timing-function: ease;
  }

  .fade-from-right-leave {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-from-right-leave-active {
    transition-duration: .5s;
    transition-property: all;
    transition-timing-function: ease;
  }

  a {
    color: #3D70FF;
    color: var(--primary-color);
    text-decoration: none;
  }

  .shadow {
    -webkit-box-shadow: 0 0 20px 0 rgba(96,96,96,0.16);
    -moz-box-shadow: 0 0 20px 0 rgba(96,96,96,0.16);
    box-shadow: 0 0 20px 0 rgba(96,96,96,0.16);
  }

  .clickable {
    cursor: pointer;
    transition: transform .3s ease, box-shadow .3s ease;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .clickable:hover {
    transform: scale(0.98);
    -webkit-box-shadow: 0 0 5px 0 rgba(96,96,96,0.16);
    -moz-box-shadow: 0 0 5px 0 rgba(96,96,96,0.16);
    box-shadow: 0 0 5px 0 rgba(96,96,96,0.16);
  }

  .button {
    color: white;
    background: #3D70FF;
    background: var(--primary-color);
    border: 0;
    outline: 0;
    border-radius: 5px;
    cursor: pointer;
    padding: 5px 10px;
  }

  .button.button-lg {
    padding: 15px 25px;
    font-size: 16px;
  }

  .valign-top {
    vertical-align: top;
  }

  .round {
    border-radius: 1000px;
  }

  .center {
    text-align: center;
  }

  .pointer {
    cursor: pointer;
  }

  .color {
    color: #3D70FF;
    color: var(--primary-color);
  }

  h1 {
    color: #3D70FF;
    color: var(--primary-color);
    font-weight: bolder;
  }

  .correct-margin-right {
    margin-right: -10px;
  }

  .column {
    display: inline-block;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 10px;
  }

  #container > .column:first-child {
    padding-left: 0;
  }

  .no-padding-left {
    padding-left: 0;
  }

  .no-padding-right {
    padding-right: 0;
  }

  .box {
    width: 100%;
    display: inline-block;
    background: white;
    padding: 25px;
    vertical-align: top;
    border-radius: 5px;
    margin-bottom: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-x: auto;
  }

  .box h2 {
    margin-top: 0;
  }

  .loader {
    background: url('./assets/bird-flying.gif') no-repeat;
    background-size: 50px 50px;
    min-height: 150px;
    background-position-x: 50%;
    background-position-y: 45%;
    animation: background-fly 1s infinite;

  }

  @keyframes background-fly {
    0% { background-position-y: 45%; }
    50% { background-position-y: 55%; }
    100% { background-position-y: 45%; }
  }

  .column-25 { width: 25%; }
  .column-30 { width: 30%; }
  .column-33 { width: 33.3333333%; }
  .column-50 { width: 50%; }
  .column-66 { width: 66.6666666%; }
  .column-70 { width: 70%; }
  .column-75 { width: 75%; }
  .column-100 { width: 100%; }

  .talking-bird {
    position: fixed;
    bottom: 30px;
    right: 105px;
    max-width: 500px;
    cursor: not-allowed;
  }

  .talking-bird:after {
    content: "";
    background: url('./assets/bird-flying.gif') no-repeat;
    background-size: 75px 75px;
    width: 100px;
    height: 100px;
    -moz-transform: scale(-1, 1);
    -webkit-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    -ms-transform: scale(-1, 1);
    transform: scale(-1, 1);
    right: -120px;
    position: absolute;
    top: 25%;
    animation: talking-bird-fly 1s infinite;
  }

  @keyframes talking-bird-fly {
    0% { background-position-y: 0; }
    50% { background-position-y: 10px; }
    100% { background-position-y: 0; }
  }

  .talking-bird .speech-bubble {
    position: relative;
    background: white;
    border-radius: .4em;
    padding: 20px;
  }

  .talking-bird .speech-bubble:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 24px solid transparent;
    border-left-color: white;
    border-right: 0;
    margin-top: -24px;
    margin-right: -24px;
  }

  .talking-bird .buttons {
    padding-top: 10px;
  }

  /* Checkbox styles */
  label {
    display: inline-flex;
    align-items: baseline;
  }
  label input[type=checkbox],
  label input[type=radio] {
    position: relative;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: inherit;
    width: 1em;
    margin: 0;
    color: inherit;
    outline: none;
    font-family: 'Font Awesome 5 Pro';
    transition: 300ms ease-out;
    color: #3D70FF;
    color: var(--primary-color);
  }
  label input[type=checkbox]::after,
  label input[type=radio]::after {
    content: '\f111';
    display: inline-block;
    text-align: center;
    width: 1em;
  }
  label input[type=checkbox]:checked::after,
  label input[type=radio]:checked::after {
    font-weight: 900;
  }
  label input[type=checkbox]:active,
  label input[type=radio]:active {
    -webkit-transform: scale(0.6);
    transform: scale(0.6);
  }
  label input[type=checkbox] + span,
  label input[type=radio] + span {
    margin-left: .35em;
  }
  label input[type=checkbox]:checked::after {
    content: '\f058';
  }
  label input[type=radio]:checked::after {
    content: '\f192';
  }

  label input[type=checkbox]:after {
    content: '\f0c8';
  }
  label input[type=checkbox]:checked::after {
    content: '\f14a';
  }

  .tui-full-calendar-timegrid-todaymarker {
    background-color: #e74c3c !important;
  }

  .tui-full-calendar-time-guide-creation {
    background-color: rgba(61, 112, 255, 0.84) !important;
    border-radius: 5px;
  }

  .tui-full-calendar-time-guide-creation-label {
    color: white !important;
  }

  .tui-full-calendar-confirm,
  .tui-full-calendar-confirm:hover {
    border-radius: 5px;
    background-color: #3D70FF !important;
    background-color: var(--primary-color) !important;
  }

  .tui-full-calendar-popup-top-line {
    background-color: #3D70FF !important;
    background-color: var(--primary-color) !important;
  }

  .tui-full-calendar-confirm span {
    color: white !important;
  }

  .tui-full-calendar-timegrid-hourmarker-line-today {
    border-top: 1px solid #e74c3c !important;
  }

  .tui-full-calendar-timegrid-hourmarker-time {
    color: #e74c3c !important;
  }

  .tui-full-calendar-dayname-container {
    display: none !important;
  }

  .tui-full-calendar-time-schedule {
    background-color: #3D70FF !important;
    background-color: var(--primary-color) !important;
    color: white !important;
    border-color: #e74c3c !important;
    border-radius: 5px;
  }

  .tui-full-calendar-time-schedule-content {
    border-color: #3D70FF !important;
    border-color: var(--primary-color) !important;
  }

  .tui-full-calendar-splitter {
    border-top: 0 !important;
  }

  .tui-full-calendar-timegrid-left,
  .tui-full-calendar-allday-left {
    width: 40px !important;
  }

  .tui-full-calendar-timegrid-right {
    margin-left: 40px !important;
  }

  .errors {
    padding: 20px;
    border-radius: 5px;
    border: 1px solid #e74c3c;
    background: #e74c3c;
    color: white;
  }

  .task,
  .ticket,
  .appointment {
    position: relative;
    padding: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    transition: all .2s ease;
  }

  .task > .icon,
  .ticket > .icon,
  .appointment > .icon {
    float: left;
    color: #3D70FF;
    color: var(--primary-color);
    padding: 0 10px;
    text-align: center;
    width: 40px;
    font-size: 1.8em;
  }

  .task > .title,
  .ticket > .title,
  .appointment > .title {
    width: 80%;
    left: 5%;
    font-weight: 500;
  }

  .task > .client,
  .ticket > .client,
  .appointment > .client {
    display: block;
    margin-left: 50px;
    font-weight: 300;
    font-style: italic;
  }

  .ticket > .updated {
    color: #3D70FF;
    color: var(--primary-color);
    padding: 3px;
    border-radius: 5px;
    font-size: .8em;
    font-weight: 600;
    float: right;
    margin-top: -20px;
  }

  .to-link {
    float: right;
    font-weight: 400;
    padding-top: 20px;
  }

  /* Top bar */
  #greeting {
    display: inline-block;
    padding-bottom: 40px;
  }

  #greeting h1,
  #greeting p {
    margin: 0;
    padding: 0;
  }

  #controls {
    display: inline-block;
    float: right;
    position: relative;
  }

  #controls div {
    display: inline-block;
  }

  #controls input {
    padding: 20px 40px 20px 20px;
    border: 0;
    border-radius: 5px;
    font-size: 16px;
    float: left;
  }

  #controls button {
    float: left;
    background: #3D70FF;
    background: var(--primary-color);
    border: 0;
    border-radius: 5px;
    padding: 20px;
    color: white;
    outline: 0;
    cursor: pointer;
    height: 58px;
    font-size: 1em;
    font-weight: bolder;
    line-height: 0;
    top: -2px;
  }

  #controls .new-popup {
    position: absolute;
    left: 60px;
    top: 78px;
    background: white;
    border-radius: 5px;
    width: 240px;
    z-index: 9999;
  }

  #controls .new-popup:before,
  #controls .alert-popup:before {
    position: absolute;
    border-style: solid;
    border-width: 0 10px 15px 10px;
    border-color: transparent transparent white transparent;
    content: " ";
    top: -15px;
    left: 15px;
  }

  .new-popup .new-button {
    float: left;
    display: inline-block;
    width: 120px;
    height: 100px;
    padding: 20px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    transition: .3s ease all;
  }

  .new-button i {
    font-size: 2em;
    height: 40px;
    color: #3D70FF;
    color: var(--primary-color);
    border-radius: 5px;
  }

  .new-button:hover,
  .alert-popup > .single-alert:hover {
    background: #f5f5f5;
  }

  #controls .alert-popup {
    position: absolute;
    top: 78px;
    left: 0;
    background: white;
    border-radius: 5px;
    width: 300px;
    z-index: 9999;
  }

  .alert-popup > .single-alert {
    width: auto;
    height: auto;
    padding: 10px 20px;
    box-sizing: border-box;
    vertical-align: top;
    border-radius: 5px;
    cursor: pointer;
    transition: .3s ease all;
  }

  .single-alert .alert-icon {
    float: left;
    position: absolute; left: 10px;
    font-size: 1.5em;
    color: #3D70FF;
    color: var(--primary-color);
    margin-top: 5px;
  }

  .single-alert .alert-title,
  .single-alert .alert-subtitle {
    margin-left: 30px;
  }

  .single-alert .alert-title {
    font-weight: 600;
  }

  .single-alert .alert-subtitle {
    font-weight: 400;
    font-style: italic;
  }

  .alerts {
    position: relative;
  }

  .notifications {
    position: absolute;
    top: -10px;
    left: -10px;
    width: 24px;
    height: 24px;
    background: #e74c3c;
    border-radius: 20px;
    text-align: center;
    color: white;
    font-size: .8em;
    line-height: 24px;
  }
  /* / Top bar */
  .data-table tr td {
    padding: 10px;
  }

  .top-data-icon {
    float: left;
    font-size: 2em;
    width: 20%;
    color: #3D70FF;
    color: var(--primary-color);
    margin-top: 5px;
  }

  .top-data-title {
    color: #3D70FF;
    color: var(--primary-color);
    font-weight: 600;
  }

  .top-data-value {
    color: #6C6C6C;
    font-size: 2em;
    font-weight: 300;
  }

  .data-table table {
    width: 100%;
    border-collapse:separate;
    border-spacing:10px;
  }

  .data-table thead {
    color: #3D70FF;
    color: var(--primary-color);
    font-weight: 600;
  }

  .data-table tr td:first-child {
    padding-left: 0;
    margin-left: -10px;
    font-weight: 600;
  }

  .data-table tr {
    background: white;
    border-radius: 5px;
  }

  .pagination {
    position: relative;
    text-align: center;
    margin: 0 auto;
  }

  .pagination .icon {
    background: rgba(0,0,0,.08);
    padding: 5px;
    border-radius: 100px;
    width: 20px;
    height: 20px;
    display: inline-block;
    margin: 5px;
    transition: all .2s ease;
  }

  .pagination .icon.active {
    background: #3D70FF;
    background: var(--primary-color);
    color: white;
  }

  .message {
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 10px;
    position: relative;
  }

  .message .thumbnail {
    display: inline-block;
    width: 15%;
    padding-right: 3%;
    vertical-align: top;
    text-align: center;
    margin-top: 5px;
  }

  .message .thumbnail img {
    width: 100%;
    border-radius: 50px;
    max-width: 50px;
    margin: 0 auto;
  }

  .message .message-text {
    display: inline-block;
    width: 82%;
    border-radius: 50px;
    vertical-align: top;
  }

  .message .message-text .name {
    color: #3D70FF;
    color: var(--primary-color);
    font-size: .9em;
    font-weight: 600;
  }

  .message .message-text .date {
    float: right;
    font-weight: 600;
    font-size: .8em;
    color: #dbdbdb;
    margin-top: 3px;
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .message-body * {
    max-width: 100% !important;
  }

  .new-message {
    position: relative;
    width: 100%;
    height: 40px;
    margin-top: 20px;
  }

  .new-message .attachment {
    display: inline-block;
    width: 10%;
  }

  .new-message .attachment label {
    display: inline-block;
    background: #3D70FF;
    background: var(--primary-color);
    color: white;
    height: 40px;
    width: 100%;
    line-height: 40px;
    text-align: center;
    border-radius: 5px 0 0 5px;
    cursor: pointer;
  }

  .new-message .attachment input {
    width: 1px;
    height: 1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .new-message .message-text {
    display: inline-block;
    width: 65%;
  }

  .new-message .message-text input {
    width: 100%;
    height: 40px;
    padding: 10px;
    box-sizing: border-box;
    border: 0;
  }

  .new-message .send-button {
    display: inline-block;
    width: 25%;
  }

  .new-message .send-button button {
    width: 100%;
    height: 40px;
    border-radius: 0 5px 5px 0;
    border: 0;
    outline: 0;
    background: #3D70FF;
    background: var(--primary-color);
    color: white;
  }

  .form-input {
    margin-bottom: 20px;
  }

  .form-input label {
    display: inline-block;
    width: 50%;
  }

  .form-input input {
    display: inline-block;
    width: 50%;
  }

  .form-input input, .input-default {
    padding: 15px 25px;
    border-radius: 5px;
    border: 0;
    outline: 0;
    font-size: 14px;
    font-weight: 400;
    color: #6C6C6C;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 20px 0 rgba(96,96,96,0.16);
    -moz-box-shadow: 0 0 20px 0 rgba(96,96,96,0.16);
    box-shadow: 0 0 20px 0 rgba(96,96,96,0.16);
  }

  .form-input input::placeholder, .input-default::placeholder {
    color: #BFD0FF;
  }

  .form-input input.loading, .input-default.loading {
    background-image: url("./assets/bird-flying.gif");
    background-size: auto 150%;
    background-repeat: no-repeat;
    background-position: right center;
    background-origin: content-box;
  }

  .not-found {
    padding: 20px;
    text-align: center;
  }

  .search-icon {
    width: 40px;
    color: #3D70FF;
    color: var(--primary-color);
  }

  .accent-color {
    color: #3D70FF;
    color: var(--primary-color);
  }

  .inline-block {
    display: inline-block;
  }

  .contact-summary-wrapper {
    padding: 10px;
    box-sizing: border-box;
  }

  .contact-summary-wrapper:nth-child(odd) {
    padding-left: 0;
  }

  .contact-summary-wrapper:nth-child(even) {
    padding-right: 0;
  }

  .contact-summary div {
    display: inline-block;
  }

  .contact-thumb {
    width: 25%;
    padding-left: 5%;
    padding-right: 5%;
    box-sizing: border-box;
    max-height: 40px;
    position: absolute;
  }

  .contact-thumb img {
    width: auto;
    height: 80px;
    margin-top: -10px;
  }

  .contact-name h4 {
    margin: 0;
  }

  .contact-info {
    width: 75%;
    left: 25%;
    position: absolute;
  }

  .contact-info div {
    width: 100%;
  }

  .contact-summary {
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
    min-height: 60px;
  }

  .new-message {
    margin-bottom: 20px;
  }

  .v--modal {
    height: auto !important;
    padding: 20px;
  }

  .right {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue